module.exports = __webpack_public_path__ + "img/royal-society-publishing-logo.7766e45e.png";